import {db} from "../../firebase/firebase";
import {collection, getDocs, query, where} from "firebase/firestore";


const getSenderInfo = async (uid: string | undefined): Promise<string | undefined> => {


    if (!uid) { // Handle cases where IDs are missing
        return "unknown"; // Or throw an error if you prefer
    }

    try {
        const usersRef = collection(db, "user_infos");
        const userQuery = query(usersRef, where("uid", "==", uid)); // Use where clause for efficient lookup

        const querySnapshot = await getDocs(userQuery);

        if (querySnapshot.empty) {
            return "unknown";
        }

        const userData = querySnapshot.docs[0].data();

        return userData.firstName && userData.lastName ? `${userData.firstName} ${userData.lastName}` : userData.email;
    } catch (error) {
        console.error("Error fetching user info:", error);
    }
};

export default getSenderInfo;
